import Switching from "./Switching"
//import ChartPage from "./ChartPage"     // 「トレンドランキング」と「類似チャート」にページを分割
import TrendRankingPage from "./TrendRankingPage"
import SimilarChartPage from "./SimilarChartPage"
import InformationPage from "./InformationPage"
import SettingsPage from "./SettingsPage"
//export {Switching, ChartPage, InformationPage, SettingsPage}
export {Switching, TrendRankingPage, SimilarChartPage, InformationPage, SettingsPage}
